import UserImageCircle from "../../UserImageCircle";
import React, {useState} from "react";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import ScrollArea from "react-scrollbar";
import {useAuth} from "../../../providers/AuthProvider";

const MeetingPopup = React.forwardRef((
    {
        meeting,
        viewerType,
        actionable,
        onCancel = () => true,
        onClose = () => true,
        onConfirm,
        onReschedule,
        onEdit = () => true, ...props
    },
    forwardRef
) => {
    const [isCalOpen, setIsCalOpen] = useState(false);

    const {auth} = useAuth();
    return (
        <div className="interview-popup" ref={forwardRef}>

            <div className="popup-actions">

                {actionable && meeting.canCancel() && (
                    <button className="btn btn-icon"
                            onClick={onCancel}
                            disabled={props.disabled}>
                        <i className="far fa-trash-alt"/>
                    </button>
                )}
                {actionable && meeting.canEdit() && (
                    <button className="btn btn-icon" onClick={onEdit}
                            disabled={props.disabled}>
                        <i className="fas fa-pencil-alt"/>
                    </button>
                )}

                {meeting.status === "Upcoming" && !!Object.keys(meeting.calendar_links)?.length && (
                    <Dropdown
                        isOpen={isCalOpen}
                        toggle={() => setIsCalOpen(!isCalOpen)}
                    >
                        <DropdownToggle
                            tag="button"
                            onClick={() => setIsCalOpen(true)}
                            data-toggle="dropdown"
                            aria-expanded={isCalOpen}
                            className="btn btn-icon"
                            disabled={props.disabled}>
                            <i className="far fa-calendar-alt"/>
                        </DropdownToggle>
                        <DropdownMenu>
                            <DropdownItem header>
                                Add to Calendar
                            </DropdownItem>
                            <DropdownItem divider/>
                            {Object.entries(meeting.calendar_links).map(([type, link]) => (
                                <DropdownItem key={type} tag="a" target="_blank" href={link}>{type}</DropdownItem>
                            ))}
                        </DropdownMenu>
                    </Dropdown>
                )}

                <button className="btn btn-icon" onClick={onClose}>
                    <i className="fas fa-times"/>
                </button>
            </div>
            <div className={"whitespace-no-wrap meeting-status " + meeting.statusClass()}>
                {meeting.statusName()}
            </div>

            <div className="flex flex-col self-stretch" style={{gap: 16}}>
                <div className="interview-name">
                    {meeting.name}
                </div>

                {viewerType === 'client' && (
                    (onReschedule && !meeting.started_at && meeting.canReschedule()) ? (
                        <button
                            className="btn btn-primary"
                            onClick={e => {
                                e.persist()
                                onReschedule(e)
                            }}
                            disabled={props.disabled || !meeting.canRequestNewInterview() || !actionable}>
                            Reschedule
                        </button>
                    ) : (!meeting.rejected_at && (
                            <div
                                className="interview-detail flex flex-row flex-nowrap items-start self-stretch"
                                style={{gap: 12}}>
                                <i className="fas fa-calendar-alt flex-grow-0"/>
                                <div className="flex flex-col items-start flex-grow" style={{gap: 12}}>
                                    <p className="whitespace-no-wrap">
                                        {meeting.acceptedTime()}
                                    </p>
                                </div>
                            </div>
                        )
                    )
                )}
                {viewerType === 'talent' && (
                    (onConfirm && meeting.awaitingConfirmationByTalent() && auth.canManageTalentOppInterviews()) ? (
                        <button
                            className="btn btn-primary"
                            onClick={e => {
                                e.persist()
                                onConfirm(e)
                            }}
                            disabled={props.disabled}>
                            {meeting.rescheduled_at ? "Update Availability" : "Confirm Availability"}
                        </button>
                    ) : (!meeting.awaitingConfirmationByTalent() && !meeting.rejected_at && (
                            <div
                                className="interview-detail flex flex-row flex-nowrap items-start self-stretch"
                                style={{gap: 12}}>
                                <i className="fas fa-calendar-alt flex-grow-0"/>
                                <div className="flex flex-col items-start flex-grow" style={{gap: 12}}>
                                    <p className="whitespace-no-wrap">
                                        {meeting.acceptedTime()}
                                    </p>
                                </div>
                            </div>
                        )
                    )
                )}


                <div className="interview-detail flex flex-row flex-nowrap items-start self-stretch"
                     style={{gap: 12}}>

                    <i className="fas fa-users flex-grow-0"/>

                    <div className="flex flex-col items-start flex-grow relative"
                         style={{gap: 12}}>
                        <p className="mb-0 whitespace-no-wrap">
                            {!!meeting.attendees(true).length
                                ? `${meeting.attendees(true).length} Attendees`
                                : 'Attendees'
                            }
                        </p>
                        <ScrollArea
                            speed={0.8}
                            smoothScrolling={true}
                            style={{maxHeight: 250}}
                            className="self-stretch"
                            stopScrollPropagation={true}
                            horizontal={false}>

                            <div className="flex flex-col items-start flex-grow" style={{gap: 12}}>

                                <div className="attendee">
                                    <UserImageCircle
                                        user={meeting.creator}
                                        hideTooltip={true}
                                        className="img-grayscale"
                                        size={36}/>
                                    <div className="flex flex-col items-start">
                                        <p className="name whitespace-no-wrap">
                                            {meeting.creator.firstNamePlusInitial()}
                                        </p>
                                        <p className="type">
                                            Organizer
                                        </p>
                                    </div>
                                </div>
                                {meeting.talentMembers().map(talent => (
                                    <div className="attendee" key={meeting.id + talent.id}>
                                        <UserImageCircle
                                            user={talent}
                                            hideTooltip={true}
                                            className="img-grayscale"
                                            size={36}/>
                                        <div className="flex flex-col items-start">
                                            <p className="name whitespace-no-wrap">
                                                {talent.firstNamePlusInitial()}
                                            </p>
                                            <p className="type">
                                                Candidate
                                            </p>
                                        </div>
                                    </div>
                                ))}
                                {meeting.clientMembers().map(clientMember => (
                                    <div className="attendee" key={meeting.id + clientMember.id}>
                                        <UserImageCircle
                                            user={clientMember}
                                            hideTooltip={true}
                                            className="img-grayscale"
                                            size={36}/>
                                        <div className="flex flex-col items-start">
                                            <p className="name whitespace-no-wrap">
                                                {clientMember.firstNamePlusInitial()}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </ScrollArea>
                    </div>
                </div>

                <div className="interview-detail flex flex-row flex-nowrap items-start self-stretch gap-3">
                    <i className="fas fa-bars flex-grow-0"/>

                    <div className="flex flex-col items-start flex-grow gap-3 overflow-x-auto">
                        <div dangerouslySetInnerHTML={{__html: meeting.conference_link}}></div>
                    </div>

                </div>

            </div>
        </div>
    )
})

export default MeetingPopup